﻿/*

Constains everything you need to complete a transaction.

Requires:
  ts.coffee

*/

// Traduction

// Returns { IsSuccess = bool, Message = string } *************************************************************************
export function findTickets(mvcapi, eventDateID, desiredTicketQty, callback, venueSectionID, ticketName, clearPreviousSelection = true) {
    const data = {
        eventDateID,
        desiredTicketQty,
        venueSectionID,
        ticketName,
        clearPreviousSelection
      };
        
    return mvcapi.postCtl('buyticket/findtickets', data
    ).success(data => callback(data)).notSuccess(data => callback(data)).commError((jqXHR, textStatus, errorThrown) => callback({
      IsSuccess: false,
      CommError: true}));
  }


// Returns { IsSuccess = bool, Message = string } *************************************************************************
export function findPackageTickets(mvcapi, packageID, eventDateIDs, desiredTicketQty, callback, venueSectionNames, clearPreviousSelection = true) {
    const data = {
        packageID,
        eventDateIDs,
        desiredTicketQty,
        venueSectionNames,
        clearPreviousSelection
      };
        
    return mvcapi.postCtl('buypackage/findtickets', data
    ).success(data => callback(data)).notSuccess(data => callback(data)).commError((jqXHR, textStatus, errorThrown) => callback({
      IsSuccess: false,
      CommError: true}));
  }

// Returns { IsSuccess = bool, Message = string } *************************************************************************
export function findTicketsByScheduleRange(mvcapi, eventDateID, desiredTicketQty, scheduleRange, callback) {
    const request = {
        eventDateID,
        desiredTicketQty,
        scheduleRange  
      };
        
    return mvcapi.postCtl('buyticket/findtickets', request
    ).success(data => callback(data)).notSuccess(data => callback(data)).commError((jqXHR, textStatus, errorThrown) => callback({
      IsSuccess: false,
      CommError: true}));
  }


        
// Take price information and then add tickets to cart
export function addTicketsToCart(mvcapi, addToCartRequest) {
    const data = addToCartRequest;
    
    return mvcapi.postCtl('buyticket/addticketstocart', addToCartRequest
    ).success(data => addToCartRequest.resultCallback(data)).notSuccess(data => addToCartRequest.resultCallback(data)).commError((jqXHR, textStatus, errorThrown) => addToCartRequest.resultCallback({
      IsSuccess: false,
      RedirectToInvalidOperation: true}));
  }


// This function save
export function addCustomerToCallbackList(mvcapi, eventDateID, firstName, lastName, phone, email, desiredTicketQty, age, callback) {
    const data = { 
        eventDateID,
        firstName,
        lastName,
        phone,
        email,
        desiredTicketQty,
        age
      };
            
    return mvcapi.postCtl('buyticket/addcustomertocallbacklist', data
    ).success(result => callback(result)).commError((jqXHR, textStatus, errorThrown) => callback({
      IsSuccess: false,
      CommError: true
    }));
  }

// Returns { IsSuccess = bool, Message = string } *************************************************************************
export function findTicketsAndAddToCart(mvcapi, eventDateID, desiredTicketQty, priceID, callback, venueSectionID, ticketName) {
    const data = { 
        eventDateID,
        desiredTicketQty
      };
            
    return mvcapi.postCtl('buyticket/findticketsandaddtocart', data
    ).success(result => callback(result)).commError((jqXHR, textStatus, errorThrown) => callback({
      IsSuccess: false,
      CommError: true
    }));
  }
